import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TableFeatureResponse } from '../../../models/api-responses';

@Component({
  selector: 'app-data-set-schema',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
  ],
  templateUrl: './data-set-schema.html',
  styleUrl: './data-set-schema.css',
})
export class DataSetSchema {
  dataSetFeatures = input<TableFeatureResponse[]>([]);

  tableColumns: {
    name: string;
    styles?: { [key: string]: string };
  }[] = [
    { name: 'Feature ID' },
    { name: 'Name' },
    { name: 'Description' },
    { name: 'Ontology' },
    { name: 'Data Type' },
    { name: 'Entity Type' },
    { name: 'Visibility' },
    { name: 'Accepted Values' },
    { name: 'Minimum Domain Value' },
    { name: 'Maximum Domain Value' },
    { name: 'Minimum Value' },
    { name: 'Maximum Value' },
    { name: 'Mean' },
    { name: 'Median' },
    { name: 'Standard Deviation' },
    { name: 'Skewness' },
    { name: 'Kurtosis' },
    { name: 'Median Absolute Deviation' },
    { name: 'Interquartile Range' },
    { name: 'Entropy' },
    { name: 'Density' },
    { name: 'Missing Percentage' },
    { name: 'Data Type Validity' },
    { name: 'Uniqueness' },
    { name: 'Accuracy Score' },
    { name: 'Imbalance' },
    { name: 'Constancy' },
    { name: 'Mode' },
    { name: 'Correlation Matrix' },
  ];
  protected readonly JSON = JSON;
}
